var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoTower = function SvgLogoTower(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 60,
    height: 60
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    id: "logo-tower",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_254",
    fill: "#FFFFFF",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "39.32,13.475 38.564,17.244 33.127,17.244 32.373,13.475 27.824,13.475 27.07,17.244 22.289,17.244  21.534,13.475 16.125,13.475 17.104,23.426 42.889,23.426 43.875,13.45  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.398,25.346l0.132,1.919l0.504,5.466l0.021,0.247l0.001-0.004l0.914,9.914l11.01,9.662L30,52.439l0.02,0.111 l11.012-9.662l1.439-15.624l0.127-1.824l0.033-0.095H17.398z M20.816,29.27h6.766v16.98l-5.75-5.238L20.816,29.27z  M32.623,46.064V29.27h6.562l-1.018,11.742L32.623,46.064z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoTower, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-tower.2bca4bdd.svg";
export { ForwardRef as ReactComponent };